import { FC } from 'react'

export const Separator: FC = () => {
  return <div className="my-8 h-px w-full bg-shade-300" />
}
